import { render, staticRenderFns } from "./diagnosisTreatComment.vue?vue&type=template&id=2c2d72c4&"
import script from "./diagnosisTreatComment.vue?vue&type=script&lang=ts&"
export * from "./diagnosisTreatComment.vue?vue&type=script&lang=ts&"
import style0 from "./diagnosisTreatComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports